import './App.scss';
import Home from './Screens/Home';
import About from './Screens/About';
import Program from './Screens/Program';
import Achievements from './Screens/Achievements';
import Placement from './Screens/Placement';
import { Linkedin,Insta } from './Assets';
import Students from './Screens/Students';
import { BrowserRouter as Router,Route,Routes } from 'react-router-dom';
import Feedback from './Screens/feedBack/form'
import StoryblokClient from "storyblok-js-client";
import { useEffect, useState } from 'react';
import FeedbackFormData from './Screens/Feedbackdata/FeedbackFormData';
const Storyblok2 = new StoryblokClient({
  accessToken: "A563QXkg20rtACOrfdm2vQtt",
});

function App() {

  const [secondStoryblokContent, setSecondStoryblokContent] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    // First Storyblok fetch
    // Second Storyblok fetch
    Storyblok2.get("cdn/stories/bt_portfolio", {
      version: "published",
    })
      .then((response2) => {
        setSecondStoryblokContent(response2.data.story.content);
        console.log("Storyblok2 Content:", response2.data.story.content);
        console.log("Storyblok2 FeedbackForm:", response2.data.story.content.feedbackForm);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Storyblok2 Error:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return null;
  }

  // console.log("Li ked in card: ", portFolioPage?.body[8]);
  console.log("Second Storyblok Content: ", secondStoryblokContent);
  console.log("FeedbackForm Array: ", secondStoryblokContent?.feedbackForm);
  console.log("FeedbackForm[0]: ", secondStoryblokContent?.feedbackForm?.[0]);
  
  return (
    <Router>
      <div className="App">
        <div className="icons">
          <a href="https://instagram.com/the_better_tomorrow_?igshid=NzZlODBkYWE4Ng==">
            <img src={Insta} alt="" /><br />
          </a>
          <a href="https://www.linkedin.com/company/better-tomorrow-training-institute/">
            <img src={Linkedin} alt="" />
          </a>
        </div>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/About' element={<About/>}/>
          <Route path='/Program' element={<Program/>}/>
          <Route path='/Achievements' element={<Achievements/>}/>
          <Route path='/Placement' element={<Placement/>}/>
          <Route path='/Feedback' element={<Feedback/>}/>
          <Route path='/Students' element={<Students/>}/>
          <Route path="/LRP" element={<FeedbackFormData cmsData={secondStoryblokContent?.feedbackForm?.[1]} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;